import CSSModules from "react-css-modules";

export default function CustomCSSModules(styles, options = {}) {
  options = {
    allowMultiple: true,
    errorWhenNotFound: false,
    ...options,
  };

  return CSSModules(styles, options);
}



// WEBPACK FOOTER //
// ./src/lib/utils/css-modules.js